/** Stored playtime is in seconds; cohort upper bounds are exclusive. */
export const PLAYTIME_COHORTS = [
  { value: "0-10", label: "0–10h", minHours: 0, maxHours: 10 },
  { value: "10-50", label: "10–50h", minHours: 10, maxHours: 50 },
  { value: "50-100", label: "50–100h", minHours: 50, maxHours: 100 },
  ...Array.from({ length: 9 }, (_, i) => {
    const minHours = (i + 1) * 100;
    return { value: `${minHours}-${minHours + 100}`, label: `${minHours}–${minHours + 100}h`, minHours, maxHours: minHours + 100 };
  }),
  { value: "1000+", label: "1000+h", minHours: 1000, maxHours: null },
];

export function findPlaytimeCohort(value: string | undefined | null) {
  return PLAYTIME_COHORTS.find(cohort => cohort.value === value);
}
